import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AppPopup',
  props: {
    title: {
      type: String,
    },
    isOpen: {
      type: Boolean,
    },
    hiddenClose: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ['close'],
  setup() {
    return {}
  },
})
